<template>
  <v-card flat tile class="form-container">
    <v-layout justify-center align-center>
      <v-flex xs10 xl6>
        <v-img :src="require('@/assets/ntd.svg')"></v-img>
      </v-flex>
    </v-layout>
    <v-card-text>
      <v-form ref="form" v-model="valid" @submit.prevent="login" class="mt-4">
        <v-text-field
          prepend-icon="mdi-account"
          autofocus
          name="username"
          label="Логин"
          id="username"
          :rules="validationRules.username"
          v-model="user.username"
          autocomplete="off"
          autocapitalize="none"
          type="text"
          required/>
        <v-text-field
          prepend-icon="mdi-lock"
          name="password"
          :rules="validationRules.password"
          label="Пароль"
          id="password"
          autocomplete="off"
          v-model="user.password"
          type="password"
          required/>
        <v-btn
          large
          block
          depressed
          color="primary"
          type="submit"
          :disabled="_isLoading || !valid"
          :loading="_isLoading">
          Войти
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'login',

  data () {
    return {
      valid: true,
      validationRules: {
        username: [
          v => !!v || 'Введите логин'
        ],
        password: [
          v => !!v || 'Введите пароль'
        ]
      },
      user: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters('auth', {
      _isLoading: 'isLoading',
      _isLoggedIn: 'isLoggedIn'
    })
  },
  methods: {
    ...mapActions('auth', {
      _login: 'login'
    }),
    async login () {
      if (this.$refs.form.validate()) {
        await this._login(this.user)
        if (this._isLoggedIn) {
          this.$refs.form.reset()
          this.$router.push({ name: 'dashboard' })
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  @require '~vuetify/src/stylus/settings/_theme.styl'
  .form-container
    background: transparent !important

  .logo-text {fill: var(--v-primary-base)}
</style>
